import { FETCH_APPDATA_FAILED, FETCH_APPDATA_REQUESTING, FETCH_APPDATA_SUCCESSED } from "../actions/actionTypes"

const initialState = {
  requesting: false,
  successful: false,
  data: [],
  no_loading_message: true,
  message: null,
  loading_message: "Fetching app data..."
}


function appReducers(state = initialState, action) {
  switch (action.type) {
    case FETCH_APPDATA_REQUESTING:
      return Object.assign({}, {
        requesting: true,
        successful: false,
        data: [],
        no_loading_message: action.params.no_loading_message,
        message: null,
        loading_message: "Fetching app data..."
      })
    case FETCH_APPDATA_SUCCESSED:
      return Object.assign({}, {
        requesting: false,
        successful: true,
        data: action.data,
        no_loading_message: state.no_loading_message,
        message: null,
        loading_message: "Fetching app data successed."
      })
    case FETCH_APPDATA_FAILED:
      return Object.assign({}, {
        requesting: false,
        successful: false,
        data: state.data,
        no_loading_message: state.no_loading_message,
        message: action.message,
        loading_message: "Fetching app data failed"
      })
    default:
      return state
  }
}

export default appReducers